import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { onlyInteger } from 'hooks/Pipe';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { use } from 'react';

export default WithApp(function ModalPurchOrderDetails(props) {
  const purchOrderDetail = props.model;
  const customerPortfolioB = props.model;
  const { purch_order, purch_order_detail } = props;
   const { base_business_partner_id } = purch_order;

  const [dataImport, setDataImport] = useState({});
  const [products, setProducts] = useState([]);
  const [medidas, setMedidas] = useState([]);
  const [warehouse, setAlmacenes] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  // function handleChange(field, value) {
  //   setDataChanging(prev => ({ ...prev, [field]: value }));
  // }
  const prodSelected = products.find(p => p.id === dataChanging.logi_product_id);

  const handleChange = (field, value) => {
    const updated = { ...dataChanging, [field]: value };

    const selectedProduct = products.find(p => p.id === updated.logi_product_id);
    const price = selectedProduct?.last_purchase_price || 0;
    const tax = selectedProduct?.TaxARRate || 0;
    const NumInBuy = selectedProduct?.NumInBuy || 0;

    const qty = parseFloat(updated.Quantity) || 0;
    const factor = NumInBuy || 0;
    const vat = parseFloat((tax / 100) || 0.18);

    const total = parseFloat((price * qty * factor).toFixed(2));
    updated.LineTotal = total;

    updated.VatSum = parseFloat((total * vat).toFixed(2));
    updated.GTotal = parseFloat((total * (1 + vat)).toFixed(2));

    setDataChanging(updated);
  };

  async function listProduct() {
    let response = await wsFindBy('logi/product', { base_business_partner_id: base_business_partner_id ,deleted_at: 'null', state: 'A' });
    if (response.success) setProducts(response.data);
  }
  async function listMedidas() {
    let response = await wsGetAll('logi/measure-unit');
    if (response.success) setMedidas(response.data);
  }

  useEffect(() => {
    if (purchOrderDetail.open) setBPartnerSelect(undefined);
  }, [purchOrderDetail.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        logi_product_id: null,
        UM: null,
        Quantity: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            ItemCode: item.PRODUCTO,
            UM: item.UNIDAD_MEDIDA,
            Quantity: item.CANTIDAD,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.logi_product_id) {
      setDataChanging((prev) => ({
        ...prev,
        logi_product_id: bPartnerSelect?.logi_product_id || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {
        listMedidas();
      };
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if(purch_order.id){
      listProduct();
    }
  }, [purch_order.id]);

  return (
    <>
      <Modal
        title={`Nuevo detalle de orden de compra`}
        model={{ open: purchOrderDetail.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.logi_product_id
            ? 'purch/purchase-order-detalle'
            : 'purch/purchase-order-detalle/multiple'
        }
        dataForce={
          dataChanging.logi_product_id
            ? (() => {
                const selectedProduct = products.find(p => p.id === dataChanging.logi_product_id);
                return {
                  purch_order_id: purch_order.id,
                  logi_product_id: dataChanging.logi_product_id,
                  UM: dataChanging.UM,
                  last_purchase_price: selectedProduct?.last_purchase_price || 0,
                  VatPrcnt: selectedProduct?.TaxARRate || 0,
                };
              })()
            : {
                purch_order_id: purch_order.id,
                logi_product_id: purchOrderDetail.valueSearch?.logi_product_id,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          {/* <Autocomplete
            disableClearable
            options={products}
            getOptionLabel={(item) => `${item.ItemName} (Código: ${item.ItemCode})`}
            renderInput={(params) => (
              <TextField {...params} label="Productos" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('logi_product_id', item?.id); setDataImport(null);}}
            value={products.find((product) => product.id === dataChanging.logi_product_id) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          /> */}
          <Autocomplete
            disableClearable
            options={products}
            getOptionLabel={(item) => `${item.ItemName} (Código: ${item.ItemCode})`}
            renderInput={(params) => (
              <TextField {...params} label="Productos" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('logi_product_id', item?.id); setDataImport(null);}}
            value={products.find((product) => product.id === dataChanging.logi_product_id) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['PRODUCTO']}
            sortDuplicate="PRODUCTO"
            downTemplate={{
              fileNameDown: `${moment(purchOrderDetail?.valueSearch?.periodo).format('YYYY-MM')}_Plantilla detalle orden de compra`,
              fields: ['PRODUCTO','UNIDAD_MEDIDA','CANTIDAD']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.logi_product_id ? (
          <>
            {/* <TextField
              label="Unidad de medida"
              fullWidth
              type="text"
              name="UM"
              margin="normal"
              value={dataChanging.UM || ''}
              onChange={(e) => handleChange('UM', e.target.value)}
              // required
            /> */}
            <Autocomplete
              disableClearable
              options={medidas}
              getOptionLabel={(item) => `${item.UgpName} (Código: ${item.UgpCode})`}
              renderInput={(params) => (
                <TextField {...params} label="Unidad de medidas" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('UM', item?.UgpCode); setDataImport(null);}}
              value={medidas.find((medida) => medida.UgpCode === dataChanging.UM) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
              disabled={!medidas.length}
            />
            <TextField
              label="Factor"
              fullWidth
              name="Factor"
              margin="normal"
              disabled
              value={parseFloat(prodSelected?.NumInBuy).toFixed(0) || ''}
            />
            <TextField
              label="Cantidad"
              fullWidth
              type="number"
              name="Quantity"
              margin="normal"
              value={dataChanging.Quantity || ''}
              onChange={(e) => handleChange('Quantity', e.target.value)}
              onKeyPress={onlyInteger}
            />
            <TextField
              label="IGV"
              fullWidth
              // type="number"
              name="VatPrcnt"
              margin="normal"
              disabled
              value={prodSelected?.TaxARRate || '18'}
              // onChange={(e) => handleChange('VatPrcnt', e.target.value)}
              // onKeyPress={onlyInteger}
            />
            <TextField
              label="Total"
              fullWidth
              type="number"
              name="LineTotal"
              margin="normal"
              value={dataChanging.LineTotal || ''}
              onChange={() => {}}
              disabled
            />
            <TextField
              label="Total Con IGV"
              fullWidth
              type="number"
              name="GTotal"
              margin="normal"
              value={dataChanging.GTotal || ''}
              onChange={() => {}}
              disabled
            />
            <TextField
              label="Descuento IGV"
              fullWidth
              type="number"
              name="VatSum"
              margin="normal"
              value={dataChanging.VatSum || ''}
              onChange={() => {}}
              disabled
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
